import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import ID from '../../_helpers/uuid';
import { css } from 'twin.macro';
import { AiOutlineClose } from 'react-icons/ai';
import { MdLocationOff, MdLocationOn } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useState, useEffect, Fragment, useRef, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { BsChevronCompactDown } from 'react-icons/bs';

import GoogleMap from './GoogleMap';
import CreateChannelModal from './components/CreateChannelModal';
import CreateChannelToggle from './components/CreateChannelToggle';
import { debounce, fetchWrapper, getLatLngFromAddress, toastWrapper } from '../../_helpers';
import PublicChannelEvents from './components/PublicChannelEvents';
import { getPublicTask, getTaskByassignedToId } from '../../_redux/actions/ActionTasks';
import { VscLoading } from 'react-icons/vsc';
import { WebSocketContext } from '../../_redux/actions/ActionSocket';
import dayjs from 'dayjs';
import UpcomingEvents from './components/UpcomingEvents';
import BobChatWidget from '../Features/Chat/BobChatWidget';

const MapContainer = styled.div`
    position: relative;
    width: 100vw;
    height: 100vh;
`;

const ChannelModeOnIndicator = styled.div`
    position: absolute;
    z-index: 2;
    top: 0;
    left: 50%;
    transform: translate(-50%, -30%);
    background-color: #24637f;
    color: white;
    padding: 1rem 5rem 1.5rem;
    border-bottom-right-radius: 35%;
    border-bottom-left-radius: 35%;
    transition: transform 400ms 400ms;
    p {
        width: 360px;
        text-align: center;
    }
    .downarrowContainer {
        text-align: center;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    :hover {
        transform: translate(-50%, 0);
    }
`;
const mapSearch = css`
    position: absolute;
    top: 2%;
    right: 0%;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
`;
const searchInput = css`
    width: 100%;
    background-color: #ffffff;
    font-size: 1.5rem;
    background-image: url('https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/search-20.png');
    background-position: 100% 50%;
    background-repeat: no-repeat;
    padding: 1rem 2rem 1rem 1rem;
    outline: none;
    padding-left: 8%;
    border-radius: 30px;
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const searchDropown = css`
	width:26%;
	max-height: 50vh;
	overflow: auto;
	border-radius: 5px;
	background-color: white;
	display: flex;
	align-self:center;
	flex-direction: column;
	0 4px 5px rgb(0 0 0 / 30%);
	border-top: 0.05px solid rgb(0 0 0 / 20%);
	margin-top: 39px;
`;
const dropdownRow = css`
    cursor: pointer;
    text-align: start;
    :hover {
        background-color: #ededed;
    }
`;

const searchItem = css`
    display: flex;
    padding: 1% 2% 0% 4%;
    span {
        padding-right: 3%;
        margin-top: -2px;
    }

    svg {
        fill: #70757a !important;
    }
`;
export const eventTypeIcon = css`
    width: 48px;
    height: 48px;
    border-radius: 50%;
`;

export const eventTypeContainer = css`
    position: absolute;
    // display: flex;
    // gap: 12px;
    // width: 80%;
    // margin: 0 10%;
    left: 10px;
    top: 10%;
    width: 120px;
    padding: 3rem 1rem;
    opacity: 1;
    max-height: 90vh;
    overflow: auto;
    border-radius: 10px;
    // box-shadow:
    //     rgba(50, 50, 93, 0.25) 0px 0px 60px -18px inset,
    //     rgba(50, 50, 93, 0.25) 0px 0px 60px -18px inset;
`;
export const eventTypeItem = css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    background-color: #50aeb0;
    // padding: 6px 12px;
    padding: 3px;
    padding-top: 12px;
    margin-bottom: 1rem;
    border-radius: 12px;
    cursor: pointer;
    p {
        white-space: nowrap;
        color: #ffffff;
        margin: 1px 0;
    }
`;

const GeoLocation = ({
    position,
    errorMessage,
    userId,
    taskList,
    getPublicTask,
    getTaskByassignedToId,
    ui,
    upcomingTaskList,
}) => {
    const [pos, setPos] = useState(null);
    const [error, setError] = useState('');
    const [isChannelCreateSelected, setIsChannelCreateSelected] = useState();
    const [sholudUpdatePublicChannels, setSholudUpdatePublicChannels] = useState(null);

    const [showCreateChannelModal, setShowCreateChannelModal] = useState(false);
    const [channelLatLong, setChannelLatLong] = useState({});

    // State variables for map overlays
    const [showTraffic, setShowTraffic] = useState(false);
    const [showTransit, setShowTransit] = useState(false);
    const [showEventRoutes, setShowEventRoutes] = useState(false);
    const [showBobChat, setShowBobChat] = useState(false);
    const [showCreateEvent, setShowCreateEvent] = useState(false);

    const inputRef = useRef();
    const [search, setSearch] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);

    const [filteredResults, setFilteredResults] = useState([]);
    const [mapLatitude, setMapLatitude] = useState();
    const [mapLongitude, setMapLongitude] = useState();
    const [searchedRoomId, setSearchedRoomId] = useState();
    // const [pageNo, setPageNo] = useState(1);
    const [chatroomEvents, setChatroomEvents] = useState([]);
    const [isEvents, setIsEvents] = useState(false);

    const [activeEvent, setActiveEvent] = useState({});
    const [activeChannel, setActiveChannel] = useState(null);

    const [publicChannels, setPublicChannels] = useState([]);

    const [searchMode, setSearchMode] = useState('channels');

    // Toggle functions for map overlays
    const toggleTraffic = () => setShowTraffic(!showTraffic);
    const toggleTransit = () => setShowTransit(!showTransit);
    const toggleEventRoutes = () => setShowEventRoutes(!showEventRoutes);
    const toggleBobChat = () => setShowBobChat(!showBobChat);
    const toggleCreateEvent = () => setShowCreateEvent(!showCreateEvent);

    // Filter upcoming tasks to include only events with location data
    const eventsWithLocations = useMemo(() => {
        return upcomingTaskList
            .filter((event) => event?.location && (event.location?.lat || event.location?.address))
            .map((event) => ({
                ...event,
                location: { ...event.location },
            }));
    }, [upcomingTaskList]);

    const getPulicGpsChatroom = async () => {
        try {
            let res = await fetchWrapper.get('/chatrooms/publicgps');
            setPublicChannels(res);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getPulicGpsChatroom();
    }, []);

    const ws = useContext(WebSocketContext);
    useEffect(() => {
        if (ws && ws.socket) {
            ws.socket.on('public_gps_pin_expires', (roomId) => {
                getPulicGpsChatroom();
            });
        }
        return () => {
            if (ws && ws.socket) {
                ws.socket.off('public_gps_pin_expires');
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [areEventsFetching, setAreEventsFetching] = useState(false);
    const [selectedMonthYear, setSelectedMonthYear] = useState(dayjs(dayjs().format('YYYY-MM-DD')).format('YYYY-MM'));

    const updateAssignedUsers = (taskId, newAssignedUsers) => {
        setChatroomEvents((prev) =>
            prev.map((taskData) =>
                taskData._id === taskId ? { ...taskData, assignedUser: newAssignedUsers } : taskData
            )
        );
    };

    const [fetchedEventTypes, setFetchedEventTypes] = useState([]);
    const [fetchedChannels, setFetchedChannels] = useState([]);

    useEffect(() => {
        if (!Array.isArray(taskList)) {
            return;
        }
        const filteredEvents = taskList?.filter((event) =>
            activeChannel ? event?.assignedChannel?.includes(activeChannel) : true
        );
        // fileteredeben
        setChatroomEvents(filteredEvents);

        setIsEvents(activeChannel || activeEvent?._id);
    }, [taskList, activeChannel]);

    const handleChatroomsEvents = async (chatroomId, eventTypeId) => {
        try {
            setAreEventsFetching(true);
            setActiveEvent({});
            setActiveChannel(chatroomId);
            setSearch('');
            if (!chatroomId && eventTypeId && !fetchedEventTypes.includes(eventTypeId)) {
                await getPublicTask(eventTypeId);
                setFetchedEventTypes((prev) => [...prev, eventTypeId]);
            }
            if (chatroomId && !fetchedChannels.includes(chatroomId)) {
                await getPublicTask(null, chatroomId);
                setFetchedChannels((prev) => [...prev, chatroomId]);
            }
        } catch (e) {
            console.log(error);
        } finally {
            setAreEventsFetching(false);
        }
    };

    const handleCloseCreateChannelModal = () => {
        setShowCreateChannelModal(false);
    };
    const handleToggleChannelCreate = () => {
        setIsChannelCreateSelected(!isChannelCreateSelected);
    };

    const updatePublicChannelsInMap = () => {
        setSholudUpdatePublicChannels(ID.uuid());
    };

    useEffect(() => {
        if (position) {
            setPos(position);
        } else if (errorMessage) {
            setError(errorMessage);
        }
    }, [position, errorMessage]);

    const handleMapSearch = () => {
        // setPageNo(1);
        const regexExp = /[.*+?^$%&@{}()|[\\]\\\\]/g;
        const searchValue = inputRef.current.value;
        if (searchValue.length === 1 && searchValue.match(regexExp)) {
            setSearch('');
        } else if (searchValue.length < 1) {
            setFilteredResults([]);
        } else {
            setActiveChannel(null);
            setSearch(inputRef.current.value.toLowerCase());
        }
    };

    const clearSearch = () => {
        // setPageNo(1);
        setSearch('');
        setFilteredResults([]);
        setChatroomEvents([]);
        setIsEvents(false);
        inputRef.current.value = '';
    };
    const searchByChannelAndEventType = async (search, pageNo = 1) => {
        try {
            setSearchLoading(true);
            setFilteredResults(publicChannels.filter((channel) => new RegExp(search, 'i').test(channel.title)));
            const response = await fetchWrapper.get(`/publicRoomTasks?limit=100&page=${pageNo}&title=${search}`);
            setChatroomEvents(response.results);
            setIsEvents(true);
        } catch (err) {
            if (err?.name === 'AbortError') return;
            toastWrapper.error(err.message);
        } finally {
            setSearchLoading(false);
        }
    };

    const searchByLocation = async (search) => {
        try {
            setSearchLoading(true);
            const locationData = await getLatLngFromAddress(search);
            if (!locationData) {
                return;
            }
            setFilteredResults([
                {
                    title: `${search} ( ${Math.round(locationData.latitude * 1000) / 1000}, ${Math.round(locationData.longitude * 1000) / 1000} )`,
                    _id: `LOCATION_${Date.now()}`,
                    addresses: [locationData],
                },
            ]);
        } catch (err) {
            toastWrapper.error(err.message);
        } finally {
            setSearchLoading(false);
        }
    };
    const onMapSearch = (result) => {
        /LOCATION/.test(result._id) || setSearchedRoomId(result._id);
        const [channelAddress] = result.addresses;
        setMapLatitude(channelAddress.latitude);
        setMapLongitude(channelAddress.longitude);
        clearSearch();
        inputRef.current.value = result.title;
        setActiveEvent({});
    };

    const handleCloseActiveEvent = () => {
        setActiveEvent({});
    };
    const handleHideEventsModal = () => {
        setIsEvents(false);
        setActiveEvent({});
    };

    // const upcomingTaskList = useMemo(() => {
    //     return getNearestUpcomingTasks(taskList || [], 5, userId);
    // }, [taskList]);

    useEffect(() => {
        if (search?.trim() && !searchLoading) {
            searchMode === 'channels' ? searchByChannelAndEventType(search) : searchByLocation(search);
        }
    }, [search]);

    useEffect(() => {
        if (!activeEvent?._id) return;

        const updated = taskList.find((t) => t._id === activeEvent._id || t.id === activeEvent.id);
        if (updated) setActiveEvent(updated);
    }, [taskList]);

    return (
        <Fragment>
            {pos && (
                <MapContainer>
                    {isChannelCreateSelected ? (
                        <ChannelModeOnIndicator>
                            <p>
                                <i>Click on your desired location, and create a channel</i>
                            </p>
                            <div className="mt-3 text-center">
                                Create channel mode ON
                                <div className="downarrowContainer">
                                    <BsChevronCompactDown />
                                </div>
                            </div>
                        </ChannelModeOnIndicator>
                    ) : null}
                    <GoogleMap
                        lat={mapLatitude ? mapLatitude : pos.coords.latitude}
                        lng={mapLongitude ? mapLongitude : pos.coords.longitude}
                        isChannelCreateSelected={isChannelCreateSelected}
                        setShowCreateChannelModal={setShowCreateChannelModal}
                        setChannelLatLong={setChannelLatLong}
                        sholudUpdatePublicChannels={sholudUpdatePublicChannels}
                        searchedRoomId={searchedRoomId ? searchedRoomId : ''}
                        handleChatroomsEvents={handleChatroomsEvents}
                        setIsEvents={setIsEvents}
                        isEvents={isEvents}
                        // isEvents={isEvents && !activeEventType}
                        chatroomEvents={chatroomEvents}
                        publicChannels={publicChannels}
                        handleHideEventsModal={handleHideEventsModal}
                        handleCloseActiveEvent={handleCloseActiveEvent}
                        // Pass map overlay state and toggle functions
                        showTraffic={showTraffic}
                        showTransit={showTransit}
                        showEventRoutes={showEventRoutes}
                        toggleTraffic={toggleTraffic}
                        toggleTransit={toggleTransit}
                        toggleEventRoutes={toggleEventRoutes}
                        // Pass filtered upcoming events with locations
                        upcomingEvents={eventsWithLocations}
                    />
                    <div css={mapSearch}>
                        {/* <div className="d-flex justify-content-center" onChange={debounce(handleMapSearch, 300)}> */}
                        <div onChange={debounce(handleMapSearch, 300)}>
                            <div
                                css={css`
                                    width: 26%;
                                    display: flex;
                                    border: 3px solid #50aeb0;
                                    border-radius: 30px;
                                    background: white;
                                    position: absolute;
                                    left: 50%;
                                    right: 50%;
                                    transform: translate(-50%, -50%);
                                    margin-top: 15px;
                                `}
                            >
                                <input placeholder="Search..." css={searchInput} ref={inputRef} />
                                {searchLoading ? (
                                    <div
                                        css={css`
                                            margin: 6px 12px 0 0;
                                        `}
                                    >
                                        <VscLoading className="spin" />
                                    </div>
                                ) : search?.length >= 1 ? (
                                    <button
                                        css={css`
                                            outline: none;
                                            color: #191919;
                                            padding: 0 1rem 0 0;
                                            display: flex;
                                            cursor: pointer;
                                            justify-content: center;
                                            align-items: center;
                                            font-size: 20px;
                                            border: none;
                                            background: transparent;
                                            border-radius: 30px;
                                            svg {
                                                transition: transform 250ms;
                                            }
                                            :hover > svg {
                                                transform: scale(1.2);
                                            }
                                        `}
                                        onClick={clearSearch}
                                        disabled={searchLoading}
                                    >
                                        <AiOutlineClose />
                                    </button>
                                ) : (
                                    <button
                                        css={css`
                                            outline: none;
                                            color: #555;
                                            padding: 0 1rem 0 0;
                                            display: flex;
                                            cursor: pointer;
                                            justify-content: center;
                                            align-items: center;
                                            font-size: 20px;
                                            border: none;
                                            background: transparent;
                                            border-radius: 30px;
                                            svg {
                                                transition: transform 250ms;
                                            }
                                            :hover > svg {
                                                transform: scale(1.2);
                                            }
                                        `}
                                        onClick={() => {
                                            setSearchMode(
                                                (prev) => ({ locations: 'channels', channels: 'locations' })[prev]
                                            );
                                        }}
                                        disabled={searchLoading}
                                    >
                                        {searchMode === 'locations' ? <MdLocationOn /> : <MdLocationOff />}
                                    </button>
                                )}
                            </div>
                        </div>

                        {filteredResults && filteredResults.length > 0 && (
                            <div css={searchDropown}>
                                {filteredResults &&
                                    filteredResults.map((result) => (
                                        <div onClick={() => onMapSearch(result)} css={dropdownRow} key={result._id}>
                                            {result.addresses.length > 0 && (
                                                <div css={searchItem}>
                                                    <span>
                                                        <MdLocationOn />
                                                    </span>
                                                    <p> {result.title}</p>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                {/* {filteredResults && filteredResults.length >= 10 && (
									<p className="text-center" onClick={regenerateMapSerachResult}>
										<a href="#"> see more</a>
									</p>
								)} */}
                            </div>
                        )}
                    </div>
                    {isEvents && (
                        <PublicChannelEvents
                            // label={activeEventType && eventTypes.find((type) => type.id === activeEventType)?.title}
                            chatroomEvents={activeEvent?._id ? [activeEvent] : chatroomEvents}
                            userId={userId}
                            updateAssignedUsers={updateAssignedUsers}
                            areEventsFetching={areEventsFetching || searchLoading}
                            activeEvent={activeEvent}
                            handleHideEventsModal={handleHideEventsModal}
                        />
                    )}
                </MapContainer>
            )}
            <CreateChannelToggle
                isChannelCreateSelected={isChannelCreateSelected}
                handleToggleChannelCreate={handleToggleChannelCreate}
                // Pass map overlay state and toggle functions
                showTraffic={showTraffic}
                showTransit={showTransit}
                showEventRoutes={showEventRoutes}
                showCreateEvent={showCreateEvent}
                showBobChat={showBobChat}
                toggleTraffic={toggleTraffic}
                toggleTransit={toggleTransit}
                toggleEventRoutes={toggleEventRoutes}
                toggleCreateEvent={toggleCreateEvent}
                toggleBobChat={toggleBobChat}
            />
            {showCreateChannelModal && (
                <CreateChannelModal
                    show={showCreateChannelModal}
                    handleClose={handleCloseCreateChannelModal}
                    channelLatLong={channelLatLong}
                    updatePublicChannelsInMap={updatePublicChannelsInMap}
                />
            )}
            <UpcomingEvents showCreateEvent={showCreateEvent} toggleCreateEvent={toggleCreateEvent} />
            {showBobChat && <BobChatWidget showBobChat={showBobChat} toggleBobChat={toggleBobChat} />}
            {error && <h1 className="center-absolute">{error}</h1>}
        </Fragment>
    );
};

GeoLocation.defaultProps = {};

const mapStateToProps = (state) => ({
    position: state.user.position,
    errorMessage: state.user.errorMessage,
    userId: state.user.user?.id,
    taskList: state.tasks.tasklist,
    ui: state.ui,
    upcomingTaskList: state.tasks.upcomingTaskList,
});

GeoLocation.propTypes = {
    position: PropTypes.object,
    errorMessage: PropTypes.string,
    userId: PropTypes.string,
};

export default connect(mapStateToProps, { getPublicTask, getTaskByassignedToId })(GeoLocation);
